export default __webpack_public_path__ + "static/download-image-2-42b540cc3bc52eb5bc2b1f8c2060cabb.png";